/* Pasta Gustosa — configuratore "Componi la tua box"
   La box coincide con il carrello: all'apertura si carica il carrello, al salvataggio
   si inviano a /cart/update.js le quantita' esatte di ogni formato. */
(() => {
  'use strict';

  const root = document.querySelector('[data-box-builder]');
  if (!root) return;

  const G = window.Gustosa || {};
  const $ = (sel, el = document) => el.querySelector(sel);
  const $$ = (sel, el = document) => Array.from(el.querySelectorAll(sel));
  const S = JSON.parse(($('[data-box-strings]') || {}).textContent || '{}');
  const MIN = (G.box && G.box.min) || 3;
  const TIERS = ((G.box && G.box.tiers) || []).filter((t) => t.qty > 0 && t.percent > 0).sort((a, b) => a.qty - b.qty);
  const FREE = (G.box && G.box.freeShipping) || 0;
  const DRAFT_KEY = 'gustosa-box-draft';

  /* ------------------------------------------------------------ catalogo dalla pagina */
  const variants = new Map();
  $$('[data-variant-row]').forEach((row) => {
    if (row.hasAttribute('data-disabled')) return;
    variants.set(row.dataset.variantId, {
      id: row.dataset.variantId,
      price: Number(row.dataset.price),
      format: row.dataset.format,
      flour: row.dataset.flour,
      color: row.dataset.color,
      row
    });
  });

  const state = new Map(); // variantId -> quantita'
  let saved = new Map(); // ultimo stato del carrello

  const packs = () => Array.from(state.values()).reduce((a, b) => a + b, 0);
  const subtotal = () => Array.from(state.entries()).reduce((sum, [id, q]) => sum + (variants.get(id)?.price || 0) * q, 0);
  // come Shopify: lo sconto automatico si ripartisce e si arrotonda riga per riga
  const discountFor = (tier) => (tier ? Array.from(state.entries()).reduce((sum, [id, q]) => sum + Math.round(((variants.get(id)?.price || 0) * q * tier.percent) / 100), 0) : 0);
  const tierFor = (n) => TIERS.filter((t) => n >= t.qty).pop();
  const nextTier = (n) => TIERS.find((t) => n < t.qty);
  const plural = (n) => (n === 1 ? S.packsOne : S.packsOther);
  const dirty = () => {
    if (state.size !== saved.size) return true;
    for (const [id, q] of state) if (saved.get(id) !== q) return true;
    return false;
  };

  function setQty(id, qty) {
    qty = Math.max(0, Math.min(99, qty | 0));
    if (qty === 0) state.delete(id);
    else state.set(id, qty);
    try { sessionStorage.setItem(DRAFT_KEY, JSON.stringify(Array.from(state.entries()))); } catch (e) { /* storage non disponibile */ }
    render();
  }

  /* ------------------------------------------------------------ righe prodotto */
  function renderRows() {
    variants.forEach((v, id) => {
      const q = state.get(id) || 0;
      const add = $('.format-row__add', v.row);
      const stepper = $('[data-box-stepper]', v.row);
      const input = $('[data-box-input]', v.row);
      v.row.classList.toggle('is-selected', q > 0);
      if (add) add.hidden = q > 0;
      if (stepper) stepper.hidden = q === 0;
      if (input && document.activeElement !== input) input.value = q;
    });
    $$('[data-flour-card]').forEach((card) => {
      const total = $$('[data-variant-row]', card).reduce((s, row) => s + (state.get(row.dataset.variantId) || 0), 0);
      card.classList.toggle('has-items', total > 0);
      $('[data-flour-count]', card).textContent = total;
    });
  }

  /* ------------------------------------------------------------ pannello riepilogo */
  function message(n) {
    if (n < MIN) {
      const missing = MIN - n;
      return G.t(missing === 1 ? S.needMoreOne : S.needMoreOther, { count: missing });
    }
    const next = nextTier(n);
    const current = tierFor(n);
    if (next && current) return G.t(S.tierUpgrade, { count: next.qty - n, percent: next.percent, current: current.percent });
    if (next) return G.t(S.tierNext, { count: next.qty - n, percent: next.percent });
    const top = tierFor(n);
    if (top) return G.t(S.tierReached, { percent: top.percent });
    return S.complete;
  }

  function progressHTML(n) {
    const max = Math.max(MIN, ...TIERS.map((t) => t.qty));
    const pct = Math.min(100, (n / max) * 100);
    const markers = [{ qty: MIN, label: MIN }].concat(TIERS.map((t) => ({ qty: t.qty, label: t.qty, title: `-${t.percent}%` })));
    return `
      <div class="box-progress">
        <div class="box-progress__label"><span>${n} ${plural(n)}</span><span>${S.minLabel}</span></div>
        <div class="box-progress__bar" style="--progress:${pct}%">
          <div class="box-progress__fill"></div>
          ${markers.map((m) => `<span class="box-progress__marker${n >= m.qty ? ' is-reached' : ''}" style="--at:${(m.qty / max) * 100}%"${m.title ? ` title="${m.title}"` : ''}>${m.label}</span>`).join('')}
        </div>
        <p class="box-progress__msg">${message(n)}</p>
      </div>`;
  }

  function slotsHTML(n) {
    const colors = [];
    state.forEach((q, id) => { for (let i = 0; i < q; i += 1) colors.push(variants.get(id)?.color || '#EFE7DC'); });
    const count = Math.max(12, Math.ceil(Math.max(n, 1) / 6) * 6);
    let html = '<div class="box-slots" aria-hidden="true">';
    for (let i = 0; i < count; i += 1) {
      const c = colors[i];
      html += `<span class="box-slot${c ? ' is-filled' : ''}${i < MIN ? ' is-min' : ''}"${c ? ` style="--c:${c}"` : ''}></span>`;
    }
    return `${html}</div>`;
  }

  function linesHTML() {
    if (!state.size) return `<p class="box-panel__empty">${S.empty}</p>`;
    let html = '<ul class="box-lines" role="list">';
    state.forEach((q, id) => {
      const v = variants.get(id);
      if (!v) return;
      html += `<li class="box-line" style="--c:${v.color}">
        <span class="box-line__dot"></span>
        <span class="box-line__name">${v.flour}<span>${v.format}</span></span>
        <span class="box-line__qty">× ${q}</span>
        <button type="button" class="box-line__remove" data-box-remove="${id}" aria-label="${S.remove} ${v.flour} ${v.format}"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>
      </li>`;
    });
    return `${html}</ul>`;
  }

  function totalsHTML(n) {
    const sub = subtotal();
    const tier = tierFor(n);
    const discount = discountFor(tier);
    const total = sub - discount;
    let ship = '';
    if (FREE > 0 && n > 0) {
      const left = FREE - total;
      const pct = Math.min(100, (total / FREE) * 100);
      ship = `<div class="shipping-bar${left <= 0 ? ' is-free' : ''}"><p>${left <= 0 ? `<strong>${S.freeShipReached}</strong>` : G.t(S.freeShipLeft, { amount: G.formatMoney(left) })}</p><div class="shipping-bar__track"><div class="shipping-bar__fill" style="--progress:${pct}%"></div></div></div>`;
    }
    return `
      ${ship}
      <div class="cart-totals">
        ${discount ? `<div class="cart-totals__row"><span>${S.subtotal}</span><span>${G.formatMoney(sub)}</span></div>
        <div class="cart-totals__row cart-totals__row--discount"><span>${S.discount} -${tier.percent}%</span><span>-${G.formatMoney(discount)}</span></div>` : ''}
        <div class="cart-totals__row cart-totals__row--total"><span>${S.total}</span><span>${G.formatMoney(total)}</span></div>
      </div>`;
  }

  function panelHTML() {
    const n = packs();
    const ready = n >= MIN;
    const toCheckout = ready && saved.size && !dirty();
    const label = toCheckout ? S.checkout : saved.size ? S.update : S.save;
    return `
      <div class="box-panel__head"><h2 class="box-panel__title">${S.title}</h2><span class="box-panel__count">${n} ${plural(n)}</span></div>
      ${slotsHTML(n)}
      ${progressHTML(n)}
      ${linesHTML()}
      ${totalsHTML(n)}
      <div class="box-panel__actions">
        <button type="button" class="btn btn--block btn--lg" data-box-save ${ready ? '' : 'disabled aria-disabled="true"'}>${label}</button>
        <div class="box-panel__tools">
          <button type="button" data-box-surprise><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M16 4h4v4M20 4l-6 6M4 20l6-6M16 20h4v-4M20 20l-5.5-5.5M4 4l5 5"/></svg>${S.surprise}</button>
          ${n ? `<button type="button" data-box-clear>${S.clear}</button>` : ''}
        </div>
        <p class="cart-note">${S.inCart} ${S.taxes}</p>
      </div>`;
  }

  function renderBar() {
    const n = packs();
    const bar = $('[data-box-bar]');
    if (!bar) return;
    const mini = $('[data-box-mini]', bar);
    const colors = [];
    state.forEach((q, id) => { for (let i = 0; i < q; i += 1) colors.push(variants.get(id)?.color); });
    const slots = Math.max(MIN, Math.min(12, n));
    mini.innerHTML = Array.from({ length: slots }, (_, i) => `<span class="${colors[i] ? 'is-filled' : ''}" style="${colors[i] ? `--c:${colors[i]}` : ''}"></span>`).join('');
    const tier = tierFor(n);
    const sub = subtotal();
    const total = sub - discountFor(tier);
    $('[data-box-bar-title]', bar).textContent = `${n} ${plural(n)} · ${G.formatMoney(total)}`;
    $('[data-box-bar-sub]', bar).innerHTML = message(n);
    const save = $('[data-box-save]', bar);
    const ready = n >= MIN;
    save.disabled = !ready;
    save.setAttribute('aria-disabled', String(!ready));
    const label = $('[data-box-save-label]', save);
    if (label) label.textContent = ready && saved.size && !dirty() ? S.checkout : S.saveShort;
  }

  function render() {
    renderRows();
    $$('[data-box-panel]').forEach((panel) => { panel.innerHTML = panelHTML(); });
    renderBar();
  }

  /* ------------------------------------------------------------ azioni */
  root.addEventListener('click', (e) => {
    const inc = e.target.closest('[data-box-inc]');
    const dec = e.target.closest('[data-box-dec]');
    const row = e.target.closest('[data-variant-row]');
    if (row && (inc || dec)) {
      const id = row.dataset.variantId;
      setQty(id, (state.get(id) || 0) + (inc ? 1 : -1));
      if (inc && !dec) {
        const input = $('[data-box-input]', row);
        requestAnimationFrame(() => { if (input && e.target.closest('.format-row__add')) $('[data-box-inc]', $('[data-box-stepper]', row))?.focus(); });
      }
    }
    const filter = e.target.closest('[data-builder-filter]');
    if (filter) {
      const tag = filter.dataset.builderFilter;
      $$('[data-builder-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b === filter)));
      $$('[data-flour-card]').forEach((card) => { card.hidden = !!tag && !` ${card.dataset.tags} `.includes(` ${tag} `); });
    }
  });
  root.addEventListener('change', (e) => {
    const input = e.target.closest('[data-box-input]');
    if (input) setQty(input.closest('[data-variant-row]').dataset.variantId, parseInt(input.value, 10) || 0);
  });

  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-box-remove]');
    if (remove) setQty(remove.dataset.boxRemove, 0);
    if (e.target.closest('[data-box-clear]')) { state.clear(); setQty('', 0); }
    if (e.target.closest('[data-box-surprise]')) surprise();
    const save = e.target.closest('[data-box-save]');
    if (save && !save.disabled) {
      if (saved.size && !dirty()) goCheckout();
      else persist(save);
    }
  });

  function surprise() {
    const pool = Array.from(variants.keys());
    const target = Math.max(packs() + MIN, (nextTier(packs()) || { qty: packs() + MIN }).qty);
    while (packs() < target && pool.length) {
      const id = pool[Math.floor(Math.random() * pool.length)];
      state.set(id, (state.get(id) || 0) + 1);
    }
    setQty(pool[0], state.get(pool[0]) || 0);
  }

  // la box e' gia' nel carrello: si passa al pagamento (stesso invio del carrello, "checkout")
  function goCheckout() {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = S.cartUrl || '/cart';
    form.innerHTML = '<input type="hidden" name="checkout" value="1">';
    document.body.appendChild(form);
    form.submit();
  }

  async function persist(button) {
    const updates = {};
    variants.forEach((v, id) => {
      const next = state.get(id) || 0;
      const before = saved.get(id) || 0;
      if (next !== before) updates[id] = next;
    });
    $$('[data-box-save]').forEach((b) => b.classList.add('is-loading'));
    try {
      await G.cart.update(updates);
      saved = new Map(state);
      try { sessionStorage.removeItem(DRAFT_KEY); } catch (e) { /* ok */ }
      render();
      sheet && sheet.close();
      G.cart.open(button);
    } catch (err) {
      G.toast(err.message || G.strings.error);
    } finally {
      $$('[data-box-save]').forEach((b) => b.classList.remove('is-loading'));
    }
  }

  /* ------------------------------------------------------------ foglio riepilogo su mobile */
  const sheetRoot = $('[data-box-sheet]');
  const sheet = sheetRoot && (() => {
    let last;
    const api = {
      isOpen: () => sheetRoot.classList.contains('is-open'),
      open(trigger) { last = trigger; sheetRoot.classList.add('is-open'); sheetRoot.setAttribute('aria-hidden', 'false'); document.body.classList.add('is-locked'); $('.modal__panel', sheetRoot).focus(); },
      close() { if (!api.isOpen()) return; sheetRoot.classList.remove('is-open'); sheetRoot.setAttribute('aria-hidden', 'true'); document.body.classList.remove('is-locked'); last && last.focus(); }
    };
    sheetRoot.addEventListener('click', (e) => { if (e.target.closest('[data-box-sheet-close]')) api.close(); });
    sheetRoot.addEventListener('keydown', (e) => { if (e.key === 'Escape') api.close(); });
    return api;
  })();
  $('[data-box-sheet-open]')?.addEventListener('click', (e) => sheet && sheet.open(e.currentTarget));

  /* ------------------------------------------------------------ avvio: carrello attuale (+ bozza non salvata) */
  async function load() {
    try {
      const data = await fetch(`${G.routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      saved = new Map();
      data.items.forEach((item) => {
        const id = String(item.variant_id);
        if (variants.has(id)) saved.set(id, (saved.get(id) || 0) + item.quantity);
      });
      state.clear();
      saved.forEach((q, id) => state.set(id, q));
      const draft = JSON.parse(sessionStorage.getItem(DRAFT_KEY) || 'null');
      if (Array.isArray(draft)) {
        state.clear();
        draft.forEach(([id, q]) => { if (variants.has(id) && q > 0) state.set(id, q); });
      }
    } catch (e) { /* senza carrello si parte da una box vuota */ }
    render();
  }

  // se il carrello cambia altrove (drawer), riallinea la box
  document.addEventListener('cart:updated', (e) => {
    const data = e.detail;
    if (!data || !data.items) return;
    const fresh = new Map();
    data.items.forEach((item) => {
      const id = String(item.variant_id);
      if (variants.has(id)) fresh.set(id, (fresh.get(id) || 0) + item.quantity);
    });
    const hadDraft = dirty();
    saved = fresh;
    if (!hadDraft) { state.clear(); fresh.forEach((q, id) => state.set(id, q)); }
    render();
  });

  load();
})();
